export const boxShadows = {
  chonkyButton:
    '0px 3px 4px rgba(0, 0, 0, 0.1), inset 0px 3px 0px rgba(255, 255, 255, 0.2)',
  luigisPantsButton:
    '0px 3px 4px rgba(0, 0, 0, 0.1), 0px 4px 20px rgba(5, 37, 91, 0.02), inset 2px 3px 0px #305087, inset -2px -2px 2px rgba(0, 0, 0, 0.25)',
  standardCard: '0px 4px 16px 2px rgba(0, 0, 0, 0.08)',
  framed:
    '0px 2px 4px rgba(0, 0, 0, 0.1), 0px 0px 0px 8px rgba(0, 0, 0, 0.05), inset 0px 3px 0px rgba(255, 255, 255, 0.2)',
}
